import React from 'react';

const ProductCard = ({ product, onSelect }) => {
  return (
    <div className="card" style={{ display: 'grid', gap: 8 }}>
      <img src={product.image} alt={product.name} style={{ width: '100%', height: 180, objectFit: 'cover', borderRadius: 12 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>{product.name}</strong>
        <span className="tag">{product.category}</span>
      </div>
      <div style={{ color: '#475569', fontSize: 14 }}>{product.short}</div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 12, color: '#64748b' }}>MOQ: {product.moq}</span>
        <button className="btn" onClick={() => onSelect(product)}>Demander un devis</button>
      </div>
    </div>
  );
};

export default ProductCard;
